import { collection, onSnapshot, addDoc, doc, setDoc, deleteDoc } from "firebase/firestore";
import { config } from "@/utils/configuration/config";
import { db } from "@/fb.js";
import { getErrorMessageFromFirebaseError } from "@/utils/utils";

export default class ModificationsRepo {

  async getModificationsForShip(ship, service) {
    // console.log("ConfigurationRepoFirebase-getConfigurationsForShip", ship.id)
    onSnapshot(
      collection(db, config.firebaseConfig.shipsCollectionName, ship.id, "ShipModifications"),
      (querySnapshot) => {
        // console.log("ConfigurationRepoFirebase-getConfigurationsForShip")
        const changes = querySnapshot.docChanges();

        changes.forEach(async (change) => {
          //console.log("ModificationsRepo-getModificationsForShip", change.type);

          if (change.type === "modified") {
            service.modifyModificationFromRepo(ship, change.doc.id, change.doc.data());
          } else if (change.type === "added") {
            service.addNewModificationFromRepo(ship, change.doc.id, change.doc.data());
          } else if (change.type === "removed") {
            service.removeModificationFromRepo(ship, change.doc.id);
          }
        });
      }
    );
  }

  createModification(shipId, name, description) {
    var errors = "";
    try {
      addDoc(collection(db, config.firebaseConfig.shipsCollectionName, shipId, "ShipModifications"), {
        name: name,
        description: description,
        actualCII: 0,
        actualETS: 0,
        actualFuelEU: 0,
        type : {},
        fuelSelected : "",
        personalizedPercentage: 0,
        newFuelConsumption : [],
        listCII : [],
        listETS : [],
        listFuelEU : [],
        economicData : {},
        ecoefficiencyIndices : [],
      });
    } catch (error) {
      //console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }
    return errors;
  }

  saveModification(shipId, modification) {
    var errors = "";
    try {
      const modificationRef = doc(
        db,
        config.firebaseConfig.shipsCollectionName,
        shipId,
        "ShipModifications",
        modification.id
      );
      setDoc(modificationRef, modification);
    } catch (error) {
      //console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }
    return errors;
  }

  deleteModification(shipId, modificationId) {
    const modificationRef = doc(
      db,
      config.firebaseConfig.shipsCollectionName,
      shipId,
      "ShipModifications",
      modificationId
    );
    deleteDoc(modificationRef);
  } 

  deleteAllModifications(shipId) {
    const modificationRef = doc(
      db,
      config.firebaseConfig.shipsCollectionName,
      shipId,
      "ShipModifications"
    );
    deleteDoc(modificationRef);
  } 
}